import { useCallback, useMemo } from 'react';
import type { PagerRequestI } from '@tacans/shared-marketplace-layer';

import { useAppDispatch, useAppSelector } from 'src/hooks/app';
import { fetchActiveOwnersThunk } from 'src/features/common/collectible/ducks/collectible/collectible.thunk';
import { selectActiveOwners } from 'src/features/common/collectible/ducks/collectible/collectible.selectors';

export const useActiveOwners = () => useAppSelector(selectActiveOwners);

export const useFetchNftActiveOwners = () => {
    const dispatch = useAppDispatch();

    return useCallback(
        async (nftId: string, pager: PagerRequestI) => {
            const res = await dispatch(fetchActiveOwnersThunk({ nftId, pager }));
            return res;
        },
        [dispatch],
    );
};

export const useActiveOwnersByIds = () => {
    const activeOwners = useActiveOwners();

    return useMemo(() => (activeOwners?.items ?? []).reduce((acum, owner) => {
        acum[owner.address] = owner.copies;
        return acum;
    }, {} as Record<string, string>), [activeOwners?.items]);
};
